/**
 * Renders the "Conversión por idioma" admin table.
 * Pure presentation — fetching + error handling is the caller's responsibility.
 */
export const LangStatsTable = ({ data }) => {
  if (!data || !Array.isArray(data.by_lang)) return null;
  const FLAG = { es: "🇪🇸 ES", en: "🇬🇧 EN", zh: "🇨🇳 ZH" };
  return (
    <section>
      <h2 className="font-label text-gold mb-3">Conversión por idioma</h2>
      <div
        className="glass-card rounded-md overflow-hidden overflow-x-auto"
        data-testid="admin-lang-stats"
      >
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-obsidian-2">
            <tr className="text-left text-faded font-label text-xs">
              <th className="p-3">Idioma</th>
              <th className="p-3 text-right">Usuarios</th>
              <th className="p-3 text-right">Verificados</th>
              <th className="p-3 text-right">Pago</th>
              <th className="p-3 text-right">% Verif</th>
              <th className="p-3 text-right">% Pago</th>
              <th className="p-3 text-right">Ingresos USD</th>
            </tr>
          </thead>
          <tbody>
            {data.by_lang.map((r) => (
              <tr
                key={r.lang}
                className="border-t border-gold-subtle/30 hover:bg-obsidian-2/40"
              >
                <td className="p-3 font-mono text-gold-light">
                  {FLAG[r.lang] || r.lang}
                </td>
                <td className="p-3 text-right">{r.users_total}</td>
                <td className="p-3 text-right">{r.users_verified}</td>
                <td className="p-3 text-right text-emerald-400">{r.users_paid}</td>
                <td className="p-3 text-right text-faded">{r.verified_pct}%</td>
                <td className="p-3 text-right text-faded">{r.paid_pct}%</td>
                <td className="p-3 text-right text-gold">
                  ${(r.revenue_usd || 0).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-faded mt-2">
        Los usuarios sin <code>preferred_lang</code> se cuentan como ES
        (predeterminado legacy).
      </p>
    </section>
  );
};
